import React from 'react';
import {List} from 'react-virtualized';

export const ListUi = ({regChild,  ...props}) => {

    return <List {...props} ref={regChild} />
}
export default ListUi;